import { MarkdownContent } from "@components/design-system/atoms/MarkdownContent";
import { DSCardWrapper } from "@components/design-system/molecules";
import { faInfoCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSpring, animated, config } from "react-spring";

export default function HintCard({
  title,
  body,
  visible,
  dataTestId,
}) {
  const styles = useSpring({
    config: config.gentle,
    opacity: visible ? 1 : 0,
    transform: visible ? "translateX(0px)" : "translateX(-8px)",
  });

  if (!title && !body) return null;

  return (
    <animated.div style={styles} role="status" aria-live="polite">
      <DSCardWrapper variant="info" dataTestId={dataTestId}>
        <div className="flex items-start gap-sm">
          <FontAwesomeIcon
            icon={faInfoCircle}
            className="text-brand mt-0.5 shrink-0"
          />
          <div>
            {title && (
              <h4 className="text-sm font-semibold text-primary mb-xs">
                {title}
              </h4>
            )}
            <MarkdownContent
              content={body}
              className="text-xs text-secondary leading-relaxed"
            />
          </div>
        </div>
      </DSCardWrapper>
    </animated.div>
  );
}
